var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.023 65.0704C48.0184 65.0704 61.7959 50.6998 61.7959 32.9727C61.7959 15.2456 48.0184 0.875 31.023 0.875C14.0275 0.875 0.25 15.2456 0.25 32.9727C0.25 50.6998 14.0275 65.0704 31.023 65.0704Z",
    fill: "url(#paint0_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1387 55.8945L52.9879 51.8796L63.4947 62.8388L59.6455 66.8537L49.1387 55.8945Z",
    fill: "url(#paint1_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7473 63.3866L60.1816 58.7614C60.8252 58.0899 61.8784 58.0899 62.5221 58.7614L71.2672 67.883C71.9108 68.5543 71.9108 69.6528 71.2672 70.3242L66.833 74.9494C66.1894 75.6207 65.1362 75.6207 64.4924 74.9494L55.7473 65.8278C55.1037 65.1565 55.1037 64.0579 55.7473 63.3866Z",
    fill: "url(#paint2_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9473 63.1766L60.1804 58.7614C60.824 58.0899 61.8771 58.0899 62.5209 58.7614L71.266 67.883C71.9096 68.5543 71.9096 69.6528 71.266 70.3242L67.6768 74.0679C67.0337 74.3446 66.2634 74.2114 65.7429 73.6686L56.3733 63.8957C56.1731 63.6871 56.0311 63.4399 55.9473 63.1766Z",
    fill: "url(#paint3_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0275 15.6602C35.2487 15.6602 38.6706 19.2292 38.6706 23.6319C38.6706 28.0348 35.2487 31.604 31.0275 31.604C26.8065 31.604 23.3848 28.035 23.3848 23.6319C23.3846 19.2294 26.8065 15.6602 31.0275 15.6602Z",
    fill: "url(#paint4_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.299 31.3976C25.9106 30.5804 23.3848 27.4131 23.3848 23.6303C23.3848 19.8478 25.9106 16.6804 29.299 15.8633C32.6876 16.6804 35.2135 19.8478 35.2135 23.6303C35.2135 27.4131 32.6876 30.5804 29.299 31.3976Z",
    fill: "url(#paint5_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4012 58.9019C36.0753 63.5847 25.9768 63.5847 17.6509 58.9019V45.5566C17.6509 37.8831 23.6696 31.6055 31.026 31.6055C38.3824 31.6055 44.4012 37.8833 44.4012 45.5566V58.9019Z",
    fill: "url(#paint6_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0183 62.3372C25.09 62.0463 21.2087 60.901 17.6509 58.8999V45.5547C17.6509 38.5927 22.6055 32.7798 29.0183 31.7617C35.4312 32.7798 40.3858 38.5927 40.3858 45.5547V58.8999C36.828 60.901 32.9467 62.0463 29.0183 62.3372Z",
    fill: "url(#paint7_linear_9643_25110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5079 54.1371C31.5079 54.7467 31.0341 55.241 30.4496 55.241C29.8648 55.241 29.3913 54.7481 29.3913 54.1328C29.3913 53.5231 29.8652 53.0289 30.4496 53.0289C31.0344 53.0289 31.5079 53.5217 31.5079 54.1371ZM27.802 39.6961C27.4162 40.151 26.7498 40.1934 26.3137 39.791C25.8777 39.3886 25.8368 38.6935 26.2227 38.2386C28.3798 35.6988 32.1386 35.5706 34.4452 37.9765C37.4049 41.0636 36.2181 46.2992 32.292 47.7129C31.8061 47.8878 31.5078 48.3263 31.5078 48.8682V49.9879C31.5078 50.5975 31.0339 51.0917 30.4495 51.0917C29.865 51.0917 29.3911 50.5975 29.3911 49.9879C29.3911 48.8031 29.2912 47.9105 29.9967 46.878C30.3822 46.314 30.9344 45.8762 31.6059 45.6344C34.0586 44.7512 34.7997 41.4678 32.9489 39.5374C31.505 38.0314 29.1455 38.116 27.802 39.6961Z",
    fill: "#0C66E4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26315 10.2762C21.2807 -2.25872 40.7651 -2.25872 52.7826 10.2762C64.8001 22.811 64.8001 43.1342 52.7826 55.6691C40.7651 68.2039 21.2807 68.2039 9.26315 55.6691C-2.75438 43.1342 -2.75438 22.811 9.26315 10.2762ZM13.6009 14.8006C3.81444 25.0084 3.81444 41.5586 13.6009 51.7665C23.3874 61.9743 39.2545 61.9743 49.041 51.7665C58.8274 41.5588 58.8274 25.0086 49.041 14.8008C39.2545 4.59288 23.3874 4.59288 13.6009 14.8006Z",
    fill: "url(#paint8_linear_9643_25110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9643_25110",
    x1: 9.44687,
    y1: 14.9487,
    x2: 54.1933,
    y2: 54.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9643_25110",
    x1: 53.6697,
    y1: 60.5948,
    x2: 58.556,
    y2: 56.9482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9643_25110",
    x1: 38.6053,
    y1: 77.0211,
    x2: 71.924,
    y2: 77.0211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9643_25110",
    x1: 39.979,
    y1: 75.6627,
    x2: 71.9155,
    y2: 75.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9643_25110",
    x1: 7.93751,
    y1: 33.0581,
    x2: 38.832,
    y2: 33.0581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9643_25110",
    x1: 11.4312,
    y1: 32.8144,
    x2: 35.3384,
    y2: 32.8144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9643_25110",
    x1: 17.6513,
    y1: 47.0097,
    x2: 44.4013,
    y2: 47.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9643_25110",
    x1: 17.6513,
    y1: 47.0494,
    x2: 40.3859,
    y2: 47.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9643_25110",
    x1: 20.3143,
    y1: 5.67876,
    x2: 40.446,
    y2: 67.2571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRole);
export default __webpack_public_path__ + "static/media/noRole.e87b52190d196dff6abc5d0b9ddcf59b.svg";
export { ForwardRef as ReactComponent };